import {useNavigate } from "react-router-dom";

export default function Navbar() {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate("/#home")
  }
  return (
     <nav className="fixed top-4 left-1/2 transform -translate-x-1/2 w-[90%] max-w-5xl px-6 py-3 bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl shadow-lg z-50 flex justify-between items-center">
      <h1 className="text-xl font-bold text-blue-600 cursor-pointer" onClick={handleClick}>Jivan Jyoti Trust</h1>
      <ul className="flex gap-6">
        <li className="cursor-pointer font-medium">
          <a href="/#home" className="transition">Home</a>
        </li>
        <li className="cursor-pointer font-medium">
           <a href="/siddharth-ptc-collage" className="transition">Program</a>
        </li>
        <li className="cursor-pointer font-medium">
           <a href="/#about" className="transition">About</a>
        </li>
        <li className="cursor-pointer font-medium">
           <a href="/#contact" className="transition">Contact Us</a>
        </li>
      </ul>
    </nav>
  );
}
